export default [
    {
        path: 'transferencia',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-transferencia' */
            '@/views/almoxarifado/transferencia/Index'
        ),
        redirect: 'transferencia/index',
        children: [
            {
                name: 'almoxarifado-transferencia-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-transferencia' */
                    '@/views/almoxarifado/transferencia/List.vue'
                ),
            },
            {
                name: 'almoxarifado-transferencia-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-transferencia' */
                    '@/views/almoxarifado/transferencia/Form.vue'
                ),
            },
            {
                name: 'almoxarifado-transferencia-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-transferencia' */
                    '@/views/almoxarifado/transferencia/Form.vue'
                ),
            },
        ],
    },
]